// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"9b5622b9","52":"9b5622b9","310":"86d69c15","352":"eb418e86","372":"d107fe59","563":"9b5622b9","820":"86d69c15","822":"86d69c15","958":"9d68a0f6","987":"86d69c15"}[chunkId] + ".chunk.css";
};